import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SubPageHeading from '../../../organisms/SubPageHeading';
import {
  subPageHeading,
  subPageNavWithEvictionMatterArizona,
  subPageNavWithEvictionMatterNevada,
  subPageNavWithCivilMatterArizona,
  subPageNavWithCivilMatterNevada,
  subPageNavWithCivilMatterNewMexico,
  subPageNavWithEvictionMatterNewMexico,
} from './EditCase.constants';
import { CIVIL_MATTER_CASE } from '../../../../global/Case.constants';
import { apiClient } from '../../../../lib/apiClient';
import EstimatedFeesBlock from '../../../molecules/EstimatedFeesBlock/EstimatedFeesBlock';
import { getStateByStateCode } from '../../../../utils/getStateByStateCode';

const EditCase = () => {
  const {
    state: { id, navPage, subNav, defendantName = '', refNum = '', stateCode, caseType },
  } = useLocation();

  const [estimatedFeesAmount, setEstimatedFeesAmount] = useState(null);

  const subPageNavExtended = useMemo(() => {
    const isArizona = stateCode === 'AZ';
    const isNevada = stateCode === 'NV';
    const isNewMexico = stateCode === 'NM';
    const isCivilMatter = caseType === CIVIL_MATTER_CASE;

    let subNavigation = null;

    if (isArizona) {
      subNavigation = isCivilMatter
        ? subPageNavWithCivilMatterArizona
        : subPageNavWithEvictionMatterArizona;
    }

    if (isNevada) {
      subNavigation = isCivilMatter
        ? subPageNavWithCivilMatterNevada
        : subPageNavWithEvictionMatterNevada;
    }

    if (isNewMexico) {
      subNavigation = isCivilMatter
        ? subPageNavWithCivilMatterNewMexico
        : subPageNavWithEvictionMatterNewMexico;
    }

    return subNavigation?.map((item) => ({
      ...item,
      state: {
        stateCode,
        navPage,
        subNav,
        id,
        defendantName,
        refNum,
        caseType,
      },
    }));
  }, [stateCode, id, caseType, defendantName]);

  useEffect(() => {
    const fetcher = async () => {
      const state = getStateByStateCode(stateCode, 'Cases');

      const {
        data: { result },
      } = await apiClient.get(`/api/${state}/${id}/fees`);

      setEstimatedFeesAmount(result?.estimatedAmount ?? null);
    };
    fetcher();
  }, [id, stateCode]);

  return (
    <>
      <SubPageHeading
        subPageHeading={
          defendantName && refNum ? `Ref. # ${refNum} | ${defendantName}` : subPageHeading
        }
        subPageHeadingRight={<EstimatedFeesBlock estimatedAmount={estimatedFeesAmount} />}
        subPageNav={subPageNavExtended}
        nav={{
          to: '/db/processing/casesearch',
          state: {
            navPage: 'Processing',
            subNav: 'Cases',
            stateCode,
          },
        }}
      />
      <Outlet />
    </>
  );
};

export default EditCase;
